module.exports = __webpack_public_path__ + "static/media/cookery-crackary-course.168f5a3f.webp";